import { LOGIN, SELECT_SHOP, UPDATE_USER_PROFILE, SET_SUBSCRIPTION } from '../actions';
import initialState from '../initialState';
import { AnyAction } from 'redux';
import { RootState } from '../../types';

const INITIAL_STATE = {
	...initialState.auth,
};

const auth = (state: RootState['auth'] = INITIAL_STATE, action: AnyAction) => {
	switch (action.type) {
		case LOGIN:
			return {
				...state,
				...action.payload,
			};

		case SELECT_SHOP:
			return {
				...state,
				user: {
					...state.user,
					shop_hash_id: action.payload.shop_hash_id,
					shop_name: action.payload.shop_name,
					currency: action.payload.currency,
					is_owner: action.payload.is_owner,
				},
			};

		case UPDATE_USER_PROFILE:
			return {
				...state,
				user: {
					...state.user,
					firstname: action.payload.firstname,
					surname: action.payload.surname,
					email: action.payload.email,
					phone: action.payload.phone,
				},
			};

		case SET_SUBSCRIPTION:
			return {
				...state,
				subscription: action.payload,
			};

		default:
			return state;
	}
};

export default auth;
